import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// Importar o arquivo CSS global para Tailwind
import "./globals.css";

import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useMemo } from "react";
import { themeSettings } from "theme";
import { ptBR } from "@mui/material/locale";

// Importar os novos componentes com Tailwind
import Layout from "./scenes/layout/index";

// Importar componentes existentes
import AddCategory from "scenes/categories/add";
import Categories from "scenes/categories/list";
import UpdateCategory from "scenes/categories/update";
import Coupons from "scenes/coupons/list";
import AddCoupons from "scenes/coupons/add";
import CrawledCouponsList from "scenes/crawled_cupons/list/index";
import CrawledCouponsListNew from "scenes/crawled_cupons/new/index";
import CrawledCouponsListRemoved from "scenes/crawled_cupons/removed/index";
import StoreCrawledCoupons from "scenes/crawled_cupons/store/index";
import Dashboard from "scenes/dashboard";
import Networks from "scenes/networks/list";
import AddSpecial from "scenes/specials/add";
import Specials from "scenes/specials/list";
import UpdateSpecial from "scenes/specials/update";
import Stores from "scenes/stores/list";
import AddStore from "scenes/stores/add";
import AddNetwork from "scenes/networks/add/index";
import UpdateStore from "scenes/stores/update/index";

import { Login } from "auth/login";
import { Logout } from "auth/logout";
import { ProtectedRoute } from "auth/ProtectedRoute";

const ProtectedLayout = () => {
  return (
    <ProtectedRoute>
      <Layout />
    </ProtectedRoute>
  );
};

const PublicLayout = () => {
  return <Layout />;
};

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode), ptBR), [mode]);

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            {/* Rotas de autenticação */}
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
            
            <Route element={<ProtectedLayout />}>
              <Route path="/crawled-coupon" element={<CrawledCouponsList />} />
              <Route path="/crawled-coupon/new" element={<CrawledCouponsListNew />} />
              <Route path="/crawled-coupon/removed" element={<CrawledCouponsListRemoved />} />
              <Route path="/crawled-coupon/store" element={<StoreCrawledCoupons />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/categories/create" element={<AddCategory />} />
              <Route path="/categories/update/:id" element={<UpdateCategory />} />
              <Route path="/stores" element={<Stores />} />
              <Route path="/stores/create" element={<AddStore />} />
              <Route path="/stores/update/:id" element={<UpdateStore />} />
              <Route path="/coupons" element={<Coupons />} />
              <Route path="/add-coupons" element={<AddCoupons />} />
              <Route path="/specials" element={<Specials />} />
              <Route path="/special/add" element={<AddSpecial />} />
              <Route path="/specials/update/:id" element={<UpdateSpecial />} />
              <Route path="/network" element={<Networks />} />
              <Route path="/network/create" element={<AddNetwork />} />
            </Route>
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;